import { AccountOpeningApplication } from "@/modules/application/components";
import type { IOperationPageProps } from "@/shared/common/types";

export const AccountOpeningApplicationPage = ({ isEdit, isCopy }: IOperationPageProps) => (
  <AccountOpeningApplication isEdit={isEdit} isCopy={isCopy}/>
);
